import React from 'react';
import Link from 'gatsby-link';
import g from 'glamorous';
import { css } from 'glamor';

import {
  normalMargin,
  largeMargin,
  largeBreakpoint,
} from '../utils/layout-units';

import {
  bodyBackgroundColor,
  linkColor,
  linkHoverColor,
} from '../utils/typography';

const Navigation = g.nav({
  display: 'flex',
  justifyContent: 'space-between',
  padding: `0 16px`,
  maxWidth: '768px',
  margin: '0 auto',
  [`@media (min-width: ${largeBreakpoint})`]: {
    padding: '0 32px',
  },
});

const navItemCss = css({
  display: 'block',
  position: 'relative',
  padding: '8px',
  margin: '8px 0',
  flex: '0 0 auto',
  textAlign: 'center',
  textTransform: 'uppercase',
  lineHeight: '16px',
  fontWeight: '600',
  userSelect: 'none',
  fontSize: '2.5vw',
  letterSpacing: '0.2px',
  [`@media (min-width: 480px)`]: {
    fontSize: '12px',
  },
});

const navItemActiveCss = css({
  color: linkHoverColor,
  boxShadow: `inset 0 -2px 0 0 ${linkHoverColor}`,
});

const MenuTrigger = g.div({
  position: 'relative',
  color: linkColor,
  textDecoration: 'none',
  'WebkitFontSmoothing': 'initial',
  'MozOsxFontSmoothing': 'initial',
  cursor: 'pointer',
  '&:hover': {
    color: linkHoverColor,
    '& > *': {
      // Show the menu!
      display: 'block',
    },
  },
});

const menuTriggerLinkCss = css({
  pointerEvents: 'none',
  paddingRight: '2px',
});

const Menu = g.div({
  position: 'absolute',
  left: '-8px',
  top: '100%',
  backgroundColor: bodyBackgroundColor,
  zIndex: 1,
  // boxShadow: `0 1px 1px 0 rgba(0, 0, 0, 0.2)`,
  display: 'none',
  padding: `0 8px`,
});

const menuItemCss = css(navItemCss, {
  textAlign: 'left',
  whiteSpace: 'nowrap',
});

const menuItemActiveCss = css({
  color: linkHoverColor,
  '&:after': {
    content: ' •'
  },
  // boxShadow: `inset 2px 0 0 0 ${linkHoverColor}`,
});

const NavLink = ({to, children, menuItem}) => (
  <Link
    to={to}
    className={`${menuItem ? menuItemCss : navItemCss}`}
    activeClassName={`${menuItem ? menuItemActiveCss : navItemActiveCss }`}
    children={children} />
);

export default () => (
  <Navigation>
    <MenuTrigger>
      <Link to="/the-realist/" className={`${navItemCss} ${menuTriggerLinkCss}`} activeClassName={`${navItemActiveCss}`}>The Realist <svg width="10" height="10"><path d="M4.5 7L7 3H2z" fill="currentColor"/></svg></Link>
      <Menu>
        <NavLink to="/the-realist/the-book/" menuItem={true}>The Book</NavLink>
        <NavLink to="/the-realist/berenice-abbott/" menuItem={true}>Berenice Abbott</NavLink>
        <NavLink to="/the-realist/man-ray/" menuItem={true}>Man Ray</NavLink>
        <NavLink to="/the-realist/elsa-von-freytag-loringhoven/" menuItem={true}>Elsa von Freytag-Loringhoven</NavLink>
        <NavLink to="/the-realist/alfred-stieglitz/" menuItem={true}>Alfred Stieglitz</NavLink>
      </Menu>
    </MenuTrigger>
    <NavLink to="/articles/">Articles</NavLink>
    {/*<NavLink to="/news">News</NavLink>*/}
    <NavLink to="/author-bio/">Author Bio</NavLink>
    <a className={`${navItemCss}`} target="_blank" href="mailto:zoffness@gmail.com?subject=Sarah+Coleman">Contact</a>
  </Navigation>
);



// WEBPACK FOOTER //
// ./src/components/sitenav.js